export const galleryGridImages = [
  "big-lightgallry/01.jpg",
  "big-lightgallry/02.jpg",
  "big-lightgallry/03.jpg",
  "big-lightgallry/04.jpg",
  "big-lightgallry/05.jpg",
  "big-lightgallry/06.jpg",
  "big-lightgallry/07.jpg",
  "big-lightgallry/08.jpg",
  "big-lightgallry/09.jpg",
  "big-lightgallry/010.jpg",
  "big-lightgallry/011.jpg",
  "big-lightgallry/012.jpg",
];

export const masonryImageData = [
  {
    id: 1,
    src: "masonry/1.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 2,
    src: "masonry/2.jpg",
    width: 1,
    height: 1,
  },
  {
    id: 3,
    src: "masonry/3.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 4,
    src: "masonry/4.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 5,
    src: "masonry/5.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 6,
    src: "masonry/6.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 7,
    src: "masonry/7.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 8,
    src: "masonry/8.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 9,
    src: "masonry/9.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 10,
    src: "masonry/10.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 11,
    src: "masonry/11.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 12,
    src: "masonry/12.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 13,
    src: "masonry/13.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 14,
    src: "masonry/14.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 15,
    src: "masonry/15.jpg",
    width: 4,
    height: 3,
  },
];

export const hoverData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export const hoverImageDataList = [
  "lightgallry/08.jpg",
  "lightgallry/09.jpg",
  "lightgallry/010.jpg",
  "lightgallry/011.jpg",
];
